export default {
	"accountsReceivable": {
		"mergeBill": "รวม",
		"createBill": "จัดทำใบแจ้งหนี้",
		"importButtom": "น้ำเข้าค่าธรรมเนียม",
		"billName": "ชื่อใบเรียกเก็บเงิน",
		"billNameInput": "กรุณากรอกชื่อสำหรับการเรียกเก็บเงิน (จำเป็น)",
		"billNameSelect": "กรุณาเลือกชื่อสำหรับการเรียกเก็บเงิน (จำเป็น)",
		"billNo": "หมายเลขการเรียกเก็บเงิน",
		"checkPersonName": "ผู้พิสูจน์ยอด",
		"confirmPersonName": "ผู้ยืนยัน",
		"confirm": "ยืนยันใบเรียกเก็บเงิน",
		"complete": "การพิสูจน์ยอดเสร็จสมบูรณ์",
		"dialogBillErrorTitle": "ยืนยันข้อความแจ้งความผิดพลาดของการเรียกเก็บเงิน",
		"dialogBillCreateTitle": "จัดทำใบแจ้งหนี้",
		"orderCount": "ความคืบหน้า (คำสั่ง)",
		"billStartDt": "วันเริ่มต้น",
		"billEndDt": "วันสิ้นสุด",
		"billingCost": "ค่าธรรมเนียมการคำนวณ ",
		"adjustCosts": "ค่าธรรมเนียมการแก้ไข",
		"finalCosts": "ยอดรวมต้นทุน",
		"checkCost": "ค่าธรรมเนียมคู่ฉบับ ",
		"differenceCosts": "ผลต่างจากการพิสูจน์ยอด ",
		"confirmDt": "เวลายืนยัน",
		"checkDt": "เวลาพิสูจน์ยอด",
		"importDialogTitle": "ค่าธรรมเนียมการนำเข้า",
		"flagTips": "กรุณาเลือกใบเรียกเก็บเงินทั้งหมดจากผู้จัดส่งรายเดียวกันที่มีสถานะยังไม่ยืนยัน ก่อนนำมารวมเข้าด้วยกัน",
		"selectDouble": "กรุณาเลือกข้อมูลอย่างน้อยสองรายการ!"
	},
	"billingConfirm": {
		"bill": "ใบเรียกเก็บเงิน",
		"bizCost": "ค่าใช้จ่ายทางธุรกิจ",
		"fixedCost": "ต้นทุนคงที่",
		"totalCost": "ต้นทุนทั้งหมด",
		"downloadAccountbill": "ดาวน์โหลดการเรียกเก็บเงิน",
		"recountBill": "คำนวณการเรียกเก็บเงินใหม่",
		"adjustAccountBill": "ปรับเปลี่ยนรอบบัญชี",
		"changeBill": "เปลี่ยนใบเรียกเก็บเงิน",
		"systemCalculation": "ระบบกำลังคำนวณ",
		"userCalculation": "การแก้ไขด้วยตนเอง",
		"finalCalculation": "ต้นทุนขั้นสุดท้าย",
		"costConfirmationProgress": "ดำเนินการยืนยันค่าธรรมเนียม",
		"billingRequestTime": "เวลาเริ่มเรียกเก็บเงิน",
		"recalculation": "คำนวณใหม่",
		"addFixedCost": "เพิ่มค่าธรรมเนียม",
		"billingItemsName": "รายการการเรียกเก็บเงิน",
		"billingDescription": "คำอธิบายเกี่ยวกับค่าธรรมเนียม",
		"orderBillTabLable": "ค่าธรรมเนียมการขนส่ง",
		"singleReConfirm": "ยกเลิกการยืนยัน",
		"orderService": "สั่งซื้อบริการ",
		"orderBillingCost": "ต้นทุนโดยประมาณ",
		"workServiceType": "บริการการดำเนินงาน",
		"orderServiceType": "ค่าธรรมเนียมที่ปรับเปลี่ยนแล้ว",
		"clear": "เคลียร์",
		"change": "ปรับเปลี่ยน",
		"exceptBill": "การเรียกเก็บเงินผิดปกติ",
		"totalPay": "จำนวนเงินทั้งหมดที่จ่ายแล้ว",
		"billInfo": "ข้อมูลเอกสาร",
		"keyWords": "ช่อง",
		"xkeyWords": "มูลค่าการแก้ไข",
		"wkeyWords": "มูลค่างาน",
		"cost": "ต้นทุน",
		"carInfo": "ข้อมูลการส่ง",
		"serviceInfo": "ข้อมูลการบริการ",
		"changeCost": "การปรับเปลี่ยนค่าธรรมเนียม",
		"beforeCost": "ราคาก่อนการแก้ไข",
		"afeterCost": "ราคาที่แก้ไขแล้ว",
		"noCharge": "ไม่คำนวนค่าธรรมเนียมรายการนี้",
		"endDtDialogTitle": "ปรับเปลี่ยนวันที่สิ้นสุด",
		"changeBillDialogTitle": "เปลี่ยนใบเรียกเก็บเงิน",
		"billNameTitle": "เปลี่ยนชื่อใบเรียกเก็บเงิน",
		"accountResetDialogTitle": "กรุณาเลือกรายการคำนวณใหม่",
		"YS_YS": "ค่าขนส่ง ",
		"pickUpTime": "วันที่รับสินค้า",
		"endTime": "วันที่ได้รับสินค้า",
		"billNameTips": "กรุณาเลือกใบเรียกเก็บเงิน ",
		"changeBillObjTips": "ยืนยันการเปลี่ยนใบเรียกเก็บเงินหรือไม่",
		"cleanAdjustTips": "ท่านแน่ใจว่าจะลบการปรับเปลี่ยนใช่หรือไม่?",
		"adjustBillEndDtTips": "กรุณาเลือกวันที่สิ้นสุด"
	},
	"reconciliation": {
		"reConfirmFn": "ยืนยันอีกครั้ง",
		"recheckFn": "การพิสูจน์ยอด",
		"importBill": "การนำเข้าและการพิสูจน์ยอด",
		"collectData": "ความคืบหน้าของการพิสูจน์ยอด",
		"oppositeValue": "มูลค่าของคู่ค้า",
		"async": "ซิงโครไนซ์",
		"fixTypeName": "สอบเทียบรุ่น",
		"oppositeTypeName": "ประเภทยานพาหนะของคู่ค้า",
		"fixPlateNo": "แก้ไขป้ายทะเบียน",
		"selectTypeBool": "ให้บริการหรือไม่",
		"serviceItems": "รายการการบริการ",
		"projectIdTips": "สินค้าที่จัดส่งไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
		"temperatureControlNoTips": "ประเภทการควบคุมอุณหภูมิไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
		"goodsTypeIdTips": "ประเภทรายการไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
		"synProvinceOriginDistrictTips": "จังหวัด/เมือง/อำเภอต้นทางของอีกฝ่ายหนึ่งไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
		"originatingSiteIdTips": "สถานที่ต้นทางไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
		"destinationProvinceTips": "จังหวัด/เมือง/อำเภอปลายทางของอีกฝ่ายหนึ่งไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
		"destinationSiteIdTips": "สถานที่ปลายทางไม่ถูกต้องและไม่สามารถซิงโครไนซ์ได้!",
		"ourStyle": "แบบฟอร์มของเรา",
		"otherStyle": "แบบฟอร์มของคู่ค้า"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/accountsReceivable/accountsReceivable.js